<template>
  <div class="info-sidebar-activity-item" >
    <div class="info-sidebar-activity-item__content">
      <div class="info-sidebar-activity-item__header">
        <app-icon name="ClockIcon" size="14px" class="info-sidebar-activity-item__header-icon"/>
        {{item.created_at | moment('Do MMMM YYYY в HH:mm:ss')}}
      </div>
      <span :style="{color: $store.getters['common/tasks/statusById'](item.status_id).color}">
        {{item.action}}
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "HistoryItem",
    props: {
      item: {
        default(){
          return {};
        }
      }
    }
  }
</script>

<style lang="scss">
  .info-sidebar-activity-item {
    /*border-left: 2px solid #e1e8ee;*/
    padding-bottom: 1px;
    padding-left: 24px;
    position: relative;
    line-height: 1.2;
    font-size: .85rem;

    &__content {
      padding-bottom: 15px;
    }

    &__header {
      display: flex;
      align-items: center;
      margin-bottom: 5px;

      &-icon {
        margin-right: 5px;
      }
    }

    &::after {
      content: "";
      width: 2px;
      height: calc(100% - 17px);
      background: #e1e8ee;
      position: absolute;
      left: 0;
      top: 17px;
    }

    &:before {
      content: "";
      border: 2px solid rgba(var(--app-primary), 1);
      background: #fff;
      left: -6px;
      position: absolute;
      top: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }
  }
</style>
